import { MaterialIcons } from "@expo/vector-icons";
import { useThemeProvider } from "@towersystems/roam-common-native";
import { Pressable, StyleSheet } from "react-native";

type AddImageTileProps = {
  width: number;
  height: number;
  margin: number;
  onPress: () => void;
};

export function AddImageTile({
  width,
  height,
  margin,
  onPress,
}: AddImageTileProps) {
  const { colors, spacings } = useThemeProvider();

  return (
    <Pressable
      style={[
        styles.button,
        {
          width,
          height,
          margin,
          borderColor: colors.borderColor,
          borderRadius: spacings.s4,
          backgroundColor: colors.surface,
        },
      ]}
      onPress={onPress}
    >
      <MaterialIcons name="add-a-photo" size={48} color={colors.borderColor} />
    </Pressable>
  );
}

const styles = StyleSheet.create({
  button: {
    borderWidth: 2,
    borderStyle: "dashed",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});
